import { Workspace } from "@/domain/workspace/models/workspace-model";

interface WorkspaceWithUrl extends Pick<Workspace, "workspaceUrl"> {}

export const makeWorkspaceUrl = ({ workspace, path }: { workspace: WorkspaceWithUrl; path: string }) => {
  if (path.startsWith("/")) {
    return `/${workspace.workspaceUrl}${path}`;
  }
  return `/${workspace.workspaceUrl}/${path}`;
};

export const makeWorkspaceSettingsUrl = ({ workspace, path }: { workspace: WorkspaceWithUrl; path: string }) => {
  if (path.startsWith("/")) {
    return `/${workspace.workspaceUrl}/settings/workspace${path}`;
  }
  return `/${workspace.workspaceUrl}/settings/workspace/${path}`;
};

export const makeSettingsUrl = ({ workspace, path }: { workspace: WorkspaceWithUrl; path: string }) => {
  if (path.startsWith("/")) {
    return `/${workspace.workspaceUrl}/settings${path}`;
  }
  return `/${workspace.workspaceUrl}/settings/${path}`;
};
